import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export function SignupPage(): JSX.Element {
  const { signup, error, loading } = useAuth();
  const [formState, setFormState] = useState({ name: '', email: '', password: '' });

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    await signup(formState);
  };

  return (
    <div className="mx-auto max-w-md space-y-8">
      <div className="space-y-3 text-center">
        <h1 className="text-3xl font-semibold text-foreground">Start your free inspection</h1>
        <p className="text-sm text-muted-foreground">
          Create an account to upload photos, run AI analysis, and export one full inspection report on us.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="glass-card space-y-4 p-6">
        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground" htmlFor="name">
            Full name
          </label>
          <input
            id="name"
            type="text"
            required
            value={formState.name}
            onChange={(event) => setFormState((prev) => ({ ...prev, name: event.target.value }))}
            className="focus-ring w-full rounded-xl border border-white/20 bg-white/70 px-3 py-2 text-sm text-foreground outline-none placeholder:text-muted-foreground dark:bg-white/10"
            placeholder="Avery Shaw"
          />
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground" htmlFor="email">
            Work email
          </label>
          <input
            id="email"
            type="email"
            required
            value={formState.email}
            onChange={(event) => setFormState((prev) => ({ ...prev, email: event.target.value }))}
            className="focus-ring w-full rounded-xl border border-white/20 bg-white/70 px-3 py-2 text-sm text-foreground outline-none placeholder:text-muted-foreground dark:bg-white/10"
            placeholder="you@agency.com"
          />
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground" htmlFor="password">
            Password
          </label>
          <input
            id="password"
            type="password"
            required
            minLength={8}
            value={formState.password}
            onChange={(event) => setFormState((prev) => ({ ...prev, password: event.target.value }))}
            className="focus-ring w-full rounded-xl border border-white/20 bg-white/70 px-3 py-2 text-sm text-foreground outline-none placeholder:text-muted-foreground dark:bg-white/10"
            placeholder="Create a strong password"
          />
          <p className="text-xs text-muted-foreground">Use at least 8 characters with a mix of letters and numbers.</p>
        </div>

        {error && <p className="rounded-lg bg-destructive/10 px-3 py-2 text-sm text-destructive">{error}</p>}

        <button
          type="submit"
          disabled={loading}
          className="focus-ring inline-flex w-full items-center justify-center rounded-full bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground shadow-primary/30 transition hover:bg-primary/90 disabled:cursor-not-allowed disabled:opacity-70"
        >
          {loading ? 'Creating account…' : 'Create account'}
        </button>
      </form>

      <p className="text-center text-sm text-muted-foreground">
        Already have an account?{' '}
        <Link to="/login" className="text-primary hover:underline">
          Log in
        </Link>
        .
      </p>
    </div>
  );
}
